import { stegaClean } from "next-sanity";
import { getI18nString, getI18nValue } from "@/lib/utils";
import { brandColorBgClass10, type BrandColor } from "@/lib/color-utils";
import type { ImageType } from "@/lib/types";
import type { BannerDataItem } from "./general-banner.types";

export function getLogo(item: BannerDataItem): ImageType | undefined {
  const logoLight = item.logo?.logoLight;
  if (!logoLight) return undefined;
  return { image: logoLight } as unknown as ImageType;
}

export function getHeadline(item: BannerDataItem): string | undefined {
  return getI18nString(item.headline) || undefined;
}

export function getBodyCopy(item: BannerDataItem) {
  return getI18nValue(item.bodyCopy) ?? undefined;
}

export function getImage(item: BannerDataItem): ImageType | undefined {
  return (item.customImage as ImageType | null) ?? undefined;
}

export function getContentBgClass(colour: string | null | undefined): string {
  const clean = stegaClean(colour);
  if (!clean) return "";
  return brandColorBgClass10[clean as BrandColor] ?? "";
}
